module.exports = __webpack_public_path__ + "static/media/spa-banner-1600.791093cc.jpg";